module.exports = __webpack_public_path__ + "static/img/gift.751cc61a.png";